module.exports = __webpack_public_path__ + "img/bermuda.5c03fe0.webp";